import React from 'react';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import { glossaire_alarm_level } from '../../../ressources/glossaires/glossaire_niveau_alarme';
import S from './Widget.module.scss';

const BADGE_CONFIG = {
  black: { class: S.badgeBlack, label: 'Arrêt' },
  red: { class: S.badgeRed, label: 'Alarme' },
  amber: { class: S.badgeAmber, label: 'Alerte' },
  blue: { class: S.badgeBlue, label: 'Vigilance' },
};

const getAlarmeBadge = (alarmLevel) => {
  const levelStr = glossaire_alarm_level[parseInt(alarmLevel)];
  if (!levelStr) {
    return { class: S.badgeGray, label: 'Pas de donnée' };
  }
  const color = levelStr.split(' ')[1].toLowerCase();
  return BADGE_CONFIG[color] || { class: S.badgeGray, label: 'Pas de donnée' };
};

const WidgetAlarmes = ({ alarmes = [] }) => {
  const latestAlarmes = alarmes.slice(0, 10);
  const hasAlarmes = latestAlarmes && latestAlarmes.length > 0;

  return (
    <div className={[S.widget, S.widgetMedium, S.widgetSimple].join(' ')}>
      <div className={S.simpleHeader}>
        <h3 className={S.simpleTitle}>{checkMot('mes_alarmes')}</h3>
      </div>
      <div className={S.simpleContent}>
        {hasAlarmes ? (
          <ul className={S.alarmeList}>
            {latestAlarmes.map((alarme, index) => {
              const badge = getAlarmeBadge(alarme.alarm_level);
              return (
                <li key={alarme.alarm_id || index} className={S.alarmeItem}>
                  <span className={[S.alarmeBadge, badge.class].join(' ')}>
                    {badge.label}
                  </span>
                  <span className={S.alarmeText}>{alarme.sensor_name}</span>
                  <span className={S.alarmeDate}>
                    {new Date(alarme.alarm_start * 1000).toLocaleDateString()}
                  </span>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className={S.emptyStateSimple}>
            <span className={S.placeholder}>{checkMot('mes_alarmes')}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default WidgetAlarmes;
